// import JS files
import '../kickstart';
import './sticky-nav-bar';
import './races-to-watch';
import { h, render } from 'preact';

// Components
import App from '../ResultsApp';
import loadJsonScript from '../utils/load-json-script';

const flags = loadJsonScript('flag_data');

const annotations = loadJsonScript('annotations_data');

render(
  <App annotations={annotations} flags={flags} />,
  document.getElementById('app')
);
